package com.arena_web.data.repository

import com.arena_web.data.api.BookingApi
import com.arena_web.data.dto.*
import com.arena_web.domain.repositories.BookingRepository

class BookingRepositoryImpl(private val bookingApi: BookingApi) : BookingRepository {

    override suspend fun createBooking(request: CreateBookingRequest): Result<BookingDto> =
        apiCall { bookingApi.createBooking(request) }

    override suspend fun editBooking(bookingId: String, request: EditBookingRequest): Result<BookingDto> =
        apiCall { bookingApi.editBooking(bookingId, request) }

    override suspend fun cancelBooking(bookingId: String): Result<BookingDto> =
        apiCall { bookingApi.cancelBooking(bookingId) }
}
